import { vuexfireMutations, firestoreAction } from 'vuexfire'
import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore';
import 'firebase/compat/auth';


const actions = {
    async createDataset(_, dataset) {
        dataset.createdAt = firebase.firestore.FieldValue.serverTimestamp()
        dataset.userId = firebase.auth().currentUser.uid
        dataset.public = false
        const doc_ref = await firebase.firestore().collection(`datasets`).add(dataset)
        return doc_ref.id
    },
    async increaseDataset(_, dataset) {
        dataset.createdAt = firebase.firestore.FieldValue.serverTimestamp()
        dataset.userId = firebase.auth().currentUser.uid
        dataset.public = false
        const doc_ref = await firebase.firestore().collection(`datasets/${dataset.datasetId}/uploads`).add(dataset)
        return doc_ref.id
    },
    updateUploadDataset(_, { datasetId, uploadId, update }) {
        firebase.firestore().doc(`datasets/${datasetId}/uploads/${uploadId}`).update(update)
    },
    deleteDataset(_, datasetId) {
        firebase.firestore().doc(`datasets/${datasetId}`).delete()
    },
    updateDataset(_, { datasetId, update }) {
        firebase.firestore().doc(`datasets/${datasetId}`).update(update)
    },
    currentDataset: firestoreAction(async ({ bindFirestoreRef }, datasetId) => {
        
        await bindFirestoreRef('dataset', 
          firebase.firestore()
            .doc(`datasets/${datasetId}`)
        )
    }),
    projectUploads: firestoreAction(({ bindFirestoreRef }, datasetId) => {
        
        bindFirestoreRef('projectUploads', 
          firebase.firestore()
            .collection(`datasets/${datasetId}/uploads`)
        )
    }),
    retrieveAllDatasetsAdmin: firestoreAction(({ bindFirestoreRef, state }) => {
        if (state.datasetsAdmin) {
          return
        }
        
        let userDatasets = bindFirestoreRef('datasetsAdmin', 
        firebase.firestore().collection(`datasets`)
        //.where('userId', 'in', [firebase.auth().currentUser.uid])
        .orderBy('createdAt', 'desc'))
    
        
  
        return userDatasets
    }),

    retrieveAllDatasets: firestoreAction(({ bindFirestoreRef, state }) => {
        if (state.datasets) {
          return
        }
        let userDatasets = bindFirestoreRef('datasets', 
          firebase.firestore().collection(`datasets`)
          .where('userId', 'in', [firebase.auth().currentUser.uid])
          .orderBy('createdAt', 'desc')
        )
        
        return userDatasets
      }),
      retrievePublicDatasets: firestoreAction(({ bindFirestoreRef, state }) => {
        
        if (state.publicDatasets) {
          return
        }
        let publicDatasets = bindFirestoreRef('publicDatasets', 
          firebase.firestore().collection(`datasets`)
          .where('public', '==', true)
          .orderBy('createdAt', 'desc')
        )
  
        return publicDatasets
      }),
}

export default actions